import API_GATEWAY from "@/services/config/main-axios";

const authService = {
  getAccessToken() {
    return localStorage.getItem("access_token");
  },

  getRefreshToken() {
    return localStorage.getItem("refresh_token");
  },

  getNewRefreshToken(oldRefreshToken) {
    return API_GATEWAY.post(
      "backoffice/userInfo/oauth/refreshToken",
      oldRefreshToken
    );
  },

  signIn(loginData) {
    return API_GATEWAY.post("backoffice/userInfo/login", loginData);
  },

  signOut(refreshToken) {
    return API_GATEWAY.post("backoffice/userInfo/oauth/logout", refreshToken);
  },

  forgetPassword(username) {
    return API_GATEWAY.post("backoffice/userInfo/forgetPassword", { username });
  },

  forgetPasswordOtp(otp, otpToken) {
    return API_GATEWAY.post("backoffice/userInfo/forgetPasswordOtp", {
      otp,
      otpToken
    });
  },

  resetPassword(newPassword, confirmNewPassword, resetPasswordToken) {
    return API_GATEWAY.post("backoffice/userInfo/resetPassword", {
      newPassword,
      confirmNewPassword,
      resetPasswordToken
    });
  },

  changePassword(newPassword, confirmNewPassword, currentPassword) {
    return API_GATEWAY.post("backoffice/userInfo/changePassword", {
      newPassword,
      confirmNewPassword,
      currentPassword
    });
  },

  register(registerData) {
    return API_GATEWAY.post("backoffice/userInfo/register", registerData);
  },

  // It's directly read into the Store for Panel.
  userInfo() {
    return API_GATEWAY.get("backoffice/userInfo");
  },

  otpInfo(otpToken) {
    return API_GATEWAY.get(`backoffice/userInfo/otp/info/${otpToken}`);
  },

  resendOtp(otpToken) {
    return API_GATEWAY.get(`backoffice/userInfo/otp/resend/${otpToken}`);
  }
};

export default authService;
